import React from "react";
import cx from "classnames";

import styles from "./Skeleton.module.scss";

interface Props {
  width: number | string,
  height?: number | string,
  rounded?: boolean,
  type?:
    "p1"
    | "p2"
    | "p3"
    | "h3"
    | "h1"
    | "h4"
    | "l1"
    | "l4"
    | "h2"
    | "h5"
    | "l2",
}

export function Skeleton({ width, height, rounded, type }: Props) {
  return (
    <div
      className={cx(styles.Skeleton, {
        [styles.rounded]: rounded,
        [styles[type]]: type,
      })}
      style={{ width, height }}
    />
  )
}

